/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2019-07-17 22:11:25
 * @LastEditTime: 2021-01-05 16:52:51
 */
import axios from 'axios'
import {
  getUrl
} from './url.js'
const CancelToken = axios.CancelToken
let cancels = []

const service = axios.create({
  // baseURL: 'http', // api的base_url
  timeout: 60000, // request timeout
  withCredentials: true
})
// 取消所有请求
export function cancelRequest () {
  cancels.forEach(cancel => {
    if (typeof cancel === 'function') {
      cancel('CANCEL')
    }
  })
  cancels = []
}
// 添加一个请求拦截器
service.interceptors.request.use(function (config) {
  config.cancelToken = new CancelToken(function (cancel) {
    cancels.push(cancel)
  })
  return config
}, function (error) {
  return Promise.reject(error)
})

// 添加一个响应拦截器
service.interceptors.response.use(function (response) {
  const pageTime = ''
  const requestTime = response.config.headers.pageTime
  const currentPageRequest = pageTime === requestTime
  response.data.currentPageRequest = currentPageRequest
  // console.log(response)
  return response
}, function (error) {
  return Promise.reject(error)
})
export const request = async function (method = 'get', url, params = {}, headers = {}) {
  let userDefined = JSON.parse(
    window.localStorage.getItem('loginMessage')
  )
  params = params || {}
  let commonWord = document.getElementById('commonWord') || {}
  let headerCSRF = document.getElementById('headerCSRF') || {}
  let companyId = document.getElementById('companyId') || {}
  let commonWordValue = commonWord.value || ''
  let defaultHeaders = {
    'X-Requested-With': 'XMLHttpRequest',
    'User-Defined': userDefined || commonWordValue
  }
  if (headerCSRF && headerCSRF.name) {
    defaultHeaders[headerCSRF.name] = headerCSRF.value
  }
  if (companyId && companyId.value) {
    defaultHeaders.purchaserId = companyId.value
  }
  let pageTime = ''
  let _method = method.toLowerCase()
  let response = {}
  let config = {
    headers: Object.assign(defaultHeaders, headers, {
      pageTime
    })
  }
  let _url = getUrl(url)
  if (_method === 'get') {
    params['_t'] = pageTime || new Date().getTime()
  }
  if (_method === 'post' || _method === 'put' || _method === 'patch') {
    let data = params
    response = await service[_method](_url, data, config)
  } else {
    config.params = params
    response = await service[_method](_url, config)
  }
  return response
}



// WEBPACK FOOTER //
// ./src/utils/httpRequest.js